export default "__VITE_ASSET__D68KNG6y__"